module.exports = __webpack_public_path__ + "static/media/church_of_christ_pl.b82d23c7.png";